var genericStyles = {
  genericShadowStyle: {
    shadowOpacity: 0.3,
    shadowRadius: 4.84,
    shadowColor: "#000",
    shadowOffset: {
      width: 3,
      height: 3
    }
  },
  generateShadowStyleWithColor: color => {
    return {
      shadowOpacity: 0.3,
      shadowRadius: 4.84,
      shadowColor: color,
      shadowOffset: {
        width: 3,
        height: 3
      }
    };
  }
};

export { genericStyles as g };
